import type { ClearRefinementsComponentTemplates } from '../../components/ClearRefinements/ClearRefinements';

const defaultTemplates: ClearRefinementsComponentTemplates = {
  resetLabel() {
    return 'Clear refinements';
  },
};

export default defaultTemplates;
